import Vue from 'vue';

export default Vue.observable({
  'entityName': 'account',
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
    {
      value: 'email',
      text: 'Email',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
        'email'
      ]
    },
    {
      value: 'username',
      text: 'Username',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },
    {
      value: 'first_name',
      text: 'First Name', //issue 205 //issue 214 //issue 236
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      //render: item => `${item.first_name} ${item.last_name}`, //issue 236
      validators: ['required']
    },
    {
      value: 'last_name',
      text: 'Last Name',
      type: 'text',
      default: null,
      //issue 236
      'table': {
        'sortable': true,
        'filter': true
      },
      //issue 236
      validators: [ 
        'required'
        //issue 215
        /*
        (field, value, item) => {
          if (item.role != 'Provider') {
            return value !== '' || 'Last name is required'
          }
          return true
        },
        */
        //issue 215
      ],
      readonly: (item) => item.role == 'Provider' || item.role == 'EMN Client',
    },
    {
      value: 'role',
      text: 'Role',
      'type': 'list',
      'table': {
        'sortable': true,
        filter: true
      },
      'list': () => {
        let types = [
          'Administrator',
          'Pharmacovigilance admin',
          'Pharmacovigilance user',
          'Data coordinator',
          //issue 175 // rimosso ruolo // 'Provider',
          'EMN Client',
        ]
        // if (state.user.role === 'Administrator') {
        //   types.unshift('Administrator')
        // }
        return types
      },
      'validators': [
        'required'
      ]
    },
    {
      value: 'status',
      text: 'Status',
      'type': 'list',
      'table': {
        'sortable': true,
        'filter': true
      },
      'list': [
        'Active',
        'Disabled'
      ],
      'validators': [
        'required'
      ]
    }
  ],
  actions: [
    //Issue 176
    { 
      "value": "disa_acc", "text": "Disable account", "icon": "mdi-account-off", "color": "primary",
      "disable" : (item, vm) => {
        if (!vm) console.log(vm) //così transpila !
        return (item.status === "Disabled")
      }
    }
    ,
    //Issue 176
    'upsert', 'audit_trail',
    { 
      "value": "remove", "text": "Remove", "icon": "mdi-delete", "color": "primary" 

      //Issue 176 
      //tolgo questo codice, ma non sarebbe stato meglio farlo (anche) lato srv ?
      /*
      ,
      "tooltip" : (item) => {
        const dataObj = new Date(item.insert_at)
        dataObj.setHours(dataObj.getHours() + 1)
        return "Deletable within 60 seconds"
      }
      ,
      "disable" : (item, vm) => {  // si può eliminare solo se è stato inserito da meno di 60 secondi (da verificare l'invio della mail)
        
        const availableTime = 60 * 1000; // Milliseconds
        const dataObj = new Date(item.insert_at)
        const now = new Date();
        const differenceInMs = now - dataObj;
        if (Math.abs(differenceInMs) > availableTime) {
          return true
        }
        
         
        //  se l'account è appena stato inserito la differenza è minore di {availableTime} secondi
        //  quindi faccio partire un timer che a scadenza disabilita il tasto
        
        setTimeout(() => {
          vm.$set(item, '_action_remove_disable', true);
        }, availableTime);

        return false
      } 
      */
      //Issue 176 

    },
  ]
})